var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8654 7.18307V13.1026C13.8654 13.5239 13.5239 13.8654 13.1026 13.8654H10.0513C9.63002 13.8654 9.28849 13.5239 9.28849 13.1026V8.90705C9.28849 8.6964 9.11773 8.52564 8.90708 8.52564H5.09298C4.88233 8.52564 4.71157 8.6964 4.71157 8.90705V13.1026C4.71157 13.5239 4.37004 13.8654 3.94875 13.8654H0.897464C0.47617 13.8654 0.134644 13.5239 0.134644 13.1026V7.18307C0.135178 6.57634 0.376633 5.99465 0.805926 5.5659L6.01599 0.355831C6.15807 0.214904 6.34985 0.135456 6.54996 0.134613H7.45009C7.65021 0.135456 7.84198 0.214904 7.98407 0.355831L13.1941 5.5659C13.6234 5.99465 13.8649 6.57634 13.8654 7.18307Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8f2067e6.svg";
export { ForwardRef as ReactComponent };